/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLastChatInfoResponse
 */
export interface GetLastChatInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof GetLastChatInfoResponse
     */
    thread?: string;
}

/**
 * Check if a given object implements the GetLastChatInfoResponse interface.
 */
export function instanceOfGetLastChatInfoResponse(value: object): value is GetLastChatInfoResponse {
    return true;
}

export function GetLastChatInfoResponseFromJSON(json: any): GetLastChatInfoResponse {
    return GetLastChatInfoResponseFromJSONTyped(json, false);
}

export function GetLastChatInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLastChatInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'thread': json['thread'] == null ? undefined : json['thread'],
    };
}

export function GetLastChatInfoResponseToJSON(json: any): GetLastChatInfoResponse {
    return GetLastChatInfoResponseToJSONTyped(json, false);
}

export function GetLastChatInfoResponseToJSONTyped(value?: GetLastChatInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thread': value['thread'],
    };
}

